// extracted by mini-css-extract-plugin
export default {"myTable":"style_myTable__9q1sw"};